/* eslint-disable */
const state = () => ({
    IsPatientTransferred: localStorage.getItem('IsPatientTransfer'),
    fromSiteName: localStorage.getItem('fromSite'),
    toSiteName: localStorage.getItem('toSite'),
    fromSiteId: localStorage.getItem('fromSiteId'),
    toSiteId: localStorage.getItem('toSiteId'),
    fromPatientName: localStorage.getItem('fromPatient'),
    fromPatientId: localStorage.getItem('fromPatientId'),
    tocGenerateBtn:false,
    opentreeforsubmitForm:false,
    opentreeforsubjectschedule:false,
    opentreeforeprosubjects:false,
    openedformsarray:[],
    openedpatientarray:[],
    openedsitesarray:[],
    openedsitesarraysubschedule:[],
    openedpatientarraysubschedule:[],
    openedformsarraysubschedule:[],
  
});

const getters = {
    getopentreeforsubjectschedule(state: { opentreeforsubjectschedule: any }) {
        return state.opentreeforsubjectschedule;
    },
    getopentreeforeprosubjects(state: { opentreeforeprosubjects: any }) {
        return state.opentreeforeprosubjects;
    },
    getopentreeforsubmitForm(state: { opentreeforsubmitForm: any }) {
        return state.opentreeforsubmitForm;
    },
    getopenedformsarraysubschedule(state: { openedformsarraysubschedule: any }) {
        return state.openedformsarraysubschedule;
    },
    getopenedpatientarraysubschedule(state: { openedpatientarraysubschedule: any }) {
        return state.openedpatientarraysubschedule;
    },
    getopenedsitesarraysubschedule(state: { openedsitesarraysubschedule: any }) {
        return state.openedsitesarraysubschedule;
    },
    getIsPatientTransfer(state: { IsPatientTransferred: any }) {
        return state.IsPatientTransferred;
    },
    getopenedformsarray(state: { openedformsarray: any }) {
        return state.openedformsarray;
    },
    getopenedpatientarray(state: { openedpatientarray: any }) {
        return state.openedpatientarray;
    },
    getopenedsitesarray(state: { openedsitesarray: any }) {
        return state.openedsitesarray;
    },
    getFromSiteName(state: { fromSiteName: any }) {
        return state.fromSiteName;
    },
    getToSiteName(state: { toSiteName: any }) {
        return state.toSiteName;
    },
    getFromSiteId(state: { fromSiteId: any }) {
        return state.fromSiteId;
    },
    getToSiteId(state: { toSiteId: any }) {
        return state.toSiteId;
    },
    getFromPatientName(state: { fromPatientName: any }) {
        return state.fromPatientName;
    },
    getFromPatientId(state: { fromPatientId: any }) {
        return state.fromPatientId;
    },
    getTocGenrateBtn(state: { tocGenerateBtn: any }) {
        return state.tocGenerateBtn;
    },


};

const actions = {
    async setopentreeforsubjectschedule({ commit }: any, data: any) {
        commit("setopentreeforsubjectschedule", data);
    },
    async setopentreeforeprosubjects({ commit }: any, data: any) {
        commit("setopentreeforeprosubjects", data);
    },
    async setopentreeforsubmitForm({ commit }: any, data: any) {
        commit("setopentreeforsubmitForm", data);
    },
    async setopenedformsarraysubschedule({ commit }: any, data: any) {
        commit("setopenedformsarraysubschedule", data);
    },
    async setopenedpatientarraysubschedule({ commit }: any, data: any) {
        commit("setopenedpatientarraysubschedule", data);
    },
    async setopenedsitesarraysubschedule({ commit }: any, data: any) {
        commit("setopenedsitesarraysubschedule", data);
    },
    async setopenedformsarray({ commit }: any, data: any) {
        commit("setopenedformsarray", data);
    },
    async setopenedpatientarray({ commit }: any, data: any) {
        commit("setopenedpatientarray", data);
    },
    async setopenedsitesarray({ commit }: any, data: any) {
        commit("setopenedsitesarray", data);
    },
    async setIsPatientTransfer({ commit }: any, data: any) {
        commit("setIsPatientTransfer", data);
    },
    async setFromSiteName({ commit }: any, data: any) {
        commit("setFromSiteName", data);
    },
    async setToSiteName({ commit }: any, data: any) {
        commit("setToSiteName", data);
    },
    async setFromSiteId({ commit }: any, data: any) {
        commit("setFromSiteId", data);
    },
    async setToSiteId({ commit }: any, data: any) {
        commit("setToSiteId", data);
    },
    async setFromPatientName({ commit }: any, data: any) {
        commit("setFromPatientName", data);
    },
    async setFromPatientId({ commit }: any, data: any) {
        commit("setFromPatientId", data);
    },
    async setTocGenerateBtn({ commit }: any, data: any) {
        commit("setTocGenerateBtn", data);
    },
};

const mutations = {
    //opentreeforsubjectschedule
    setopentreeforsubjectschedule(state: { opentreeforsubjectschedule: any }, opentreeforsubjectscheduleData: any) {
        state.opentreeforsubjectschedule = opentreeforsubjectscheduleData;
    },
    setopentreeforeprosubjects(state: { opentreeforeprosubjects: any }, opentreeforeprosubjectsData: any) {
        state.opentreeforeprosubjects = opentreeforeprosubjectsData;
    },
    setopentreeforsubmitForm(state: { opentreeforsubmitForm: any }, opentreeforsubmitFormData: any) {
        state.opentreeforsubmitForm = opentreeforsubmitFormData;
    },
    setopenedformsarraysubschedule(state: { openedformsarraysubschedule: any }, openedformsarraysubscheduleData: any) {
        state.openedformsarraysubschedule = openedformsarraysubscheduleData;
    },
    setopenedpatientarraysubschedule(state: { openedpatientarraysubschedule: any }, openedpatientarraysubscheduleData: any) {
        state.openedpatientarraysubschedule = openedpatientarraysubscheduleData;
    },
    setopenedsitesarraysubschedule(state: { openedsitesarraysubschedule: any }, openedsitesarraysubscheduleData: any) {
        state.openedsitesarraysubschedule = openedsitesarraysubscheduleData;
    },
    setopenedformsarray(state: { openedformsarray: any }, openedformsarrayData: any) {
        state.openedformsarray = openedformsarrayData;
    },
    setopenedpatientarray(state: { openedpatientarray: any }, openedpatientarrayData: any) {
        state.openedpatientarray = openedpatientarrayData;
    },
    setopenedsitesarray(state: { openedsitesarray: any }, openedsitesarrayData: any) {
        state.openedsitesarray = openedsitesarrayData;
    },
    setIsPatientTransfer(state: { IsPatientTransferred: any }, IsPatientTransferredData: any) {
        state.IsPatientTransferred = IsPatientTransferredData;
        localStorage.setItem("IsPatientTransfer", IsPatientTransferredData);
    },
    setFromSiteName(state: { fromSiteName: any }, siteNameData: any) {
        state.fromSiteName = siteNameData;
        localStorage.setItem("fromSite", siteNameData);
    },
    setToSiteName(state: { toSiteName: any }, toSiteNameData: any) {
        state.toSiteName = toSiteNameData;
        localStorage.setItem("toSite", toSiteNameData);
    },
    setFromSiteId(state: { fromSiteId: any }, fromSiteIdData: any) {
        state.fromSiteId = fromSiteIdData;
        localStorage.setItem("fromSiteId", fromSiteIdData);
    },
    setToSiteId(state: { toSiteId: any }, toSiteIdData: any) {
        state.toSiteId = toSiteIdData;
        localStorage.setItem("toSiteId", toSiteIdData);
    },
    setFromPatientName(state: { fromPatientName: any }, fromPatientData: any) {
        state.fromPatientName = fromPatientData;
        localStorage.setItem("fromPatient", fromPatientData);
    },
    setFromPatientId(state: { fromPatientId: any }, fromPatientIdData: any) {
        state.fromPatientId = fromPatientIdData;
        localStorage.setItem("fromPatientId", fromPatientIdData);
    },
    setTocGenerateBtn(state: { tocGenerateBtn: any }, tocGenerateBtnData: any) {
        state.tocGenerateBtn = tocGenerateBtnData;
        localStorage.setItem("tocGenerateBtn", tocGenerateBtnData);
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}

